<template>
  <v-card class="ma-2">
    <v-toolbar dense>
      <v-toolbar-title>Equivalência de Planos - Alterar</v-toolbar-title>
      <v-spacer />
      <v-btn small @click="save">
        <v-icon small title="Create">fas fa-save</v-icon>
      </v-btn>
      <v-btn
        :disabled="!equivConf.referencePlan"
        small
        @click="
          $router.push(
            `/equivalence_configuration?recordId=${equivConf.referencePlan.id}`,
          )
        "
      >
        <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
      </v-btn>
    </v-toolbar>
    <div class="ma-4">
      <v-row align-content="stretch" dense>
        <v-col class="text-subtitle-1">Dados Principais</v-col>
      </v-row>
      <v-row align-content="stretch" dense>
        <v-col cols="4">
          Operadora Referência<br /><span v-if="equivConf.referencePlan">{{
            equivConf.referencePlan.carrierName
          }}</span>
        </v-col>
        <v-col cols="4">
          Plano Referência<br /><span v-if="equivConf.referencePlan">{{
            equivConf.referencePlan.productCode
          }}</span>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="4">
          <br />
          <CarrierSelect
            label="Operadora Equivalente*"
            :highlights="configuredCarriers"
            @update:carrierId="onUpdateCarrierId"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <PlanMultiSelect
            leftLabel="Planos Equivalentes*"
            rightLabel="Plano(s) Selecionado(s)"
            :carrierId="carrierId"
            :equivalenceConfigurationId="equivalenceConfigurationId"
            @update:selectedPlans="onSelectedsPlans"
            ref="planMultiSelect"
          />
        </v-col>
      </v-row>
    </div>

    <DlgPostSave ref="dlgPostSave" @select="onDlgPostSave" />
    <DlgConfirmCancel
      ref="dlgConfirmCancel"
      @select="onDlgConfirmCancel"
      title="Configurão não salva !"
      message="As alterações ainda não foram salvas e serão perdidas caso continue. Deseja continuar mesmo assoim?"
    />
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
  </v-card>
</template>

<script>
import {mapMutations} from 'vuex';
import EquivalenceConfigurationService from '@/services/insurancepricing/EquivalenceConfigurationService';
import PlanEquivalenceConfigurationService from '@/services/insurancepricing/PlanEquivalenceConfigurationService';
import CarrierSelect from '@/components/carrier-select';
import PlanMultiSelect from './components/plan-multi-select.vue';
import DlgPostSave from './components/dlg-post-save.vue';
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';

const equivConfService = new EquivalenceConfigurationService();
const planEquivConfService = new PlanEquivalenceConfigurationService();

export default {
  components: {CarrierSelect, PlanMultiSelect, DlgPostSave, DlgConfirmCancel},

  data() {
    return {
      equivConf: {},
      carrierId: null,
      selectedPlans: [],
      equivalenceConfigurationId: null,
      configuredCarriers: [],
    };
  },

  computed: {},

  methods: {
    ...mapMutations(['toogleDialogLoading']),

    onUpdateCarrierId(value) {
      this.carrierId = value;
    },

    onSelectedsPlans(value) {
      this.selectedPlans = value;
    },

    onDlgPostSave(value) {
      if (value == 'continuar') {
        return;
      }
      this.$router.push({
        name: 'prov_equiv_conf',
        params: {keyId: this.equivConf.id},
      });
    },

    onDlgConfirmCancel(value) {
      if (value == 'nao') {
        return;
      }
      this.$refs.planMultiSelect.loadPlans();
    },

    async save() {
      const equivalenceConfigurationId = this.equivalenceConfigurationId;
      const carrierId = this.carrierId;
      this.toogleDialogLoading(true);
      const data = this.selectedPlans.map(function (e) {
        return {
          id: e._id,
          equivalentPlan: {id: e.id},
          //equivalenceConfiguration: {id: equivalenceConfigurationId},
          downGrade: e.downGrade,
          upGrade: e.upGrade,
          inheritPlanEquivalenceConfigurations: e.children.map(function (c) {
            return {
              id: c._id,
              plan: {id: c.id},
            };
          }),
        };
      });
      try {
        let response = await planEquivConfService.save(
          equivalenceConfigurationId,
          carrierId,
          data,
        );
        this.selectedPlans = response.data;
        await this.loadEquivConfService();
        this.toogleDialogLoading(false);
        this.$refs.dlgPostSave.show();
      } catch (error) {
        console.log(error);
        this.toogleDialogLoading(false);
      }
    },
    remove() {},

    async loadEquivConfService() {
      try {
        const resp = await equivConfService.get(
          this.equivalenceConfigurationId,
        );
        this.equivConf = resp.data;
        this.configuredCarriers =
          this.equivConf.planEquivalenceConfigurationList
            .map((e) => e.equivalentPlan.carrierId)
            .filter((v, i, a) => a.indexOf(v) === i);
      } catch (e) {
        console.log(e);
      } finally {
        this.toogleDialogLoading(false);
      }
    },
  },

  async created() {
    this.equivalenceConfigurationId = this.$route.params.keyId;
    this.toogleDialogLoading(true);
    await this.loadEquivConfService();
  },
};
</script>

<style scoped>
.title {
  font-size: 120%;
}
</style>